import { useCallback, useMemo, useRef, useState } from 'react';
import { Button } from '@/components/ui/Button/Button';
import { ContextMenu } from '@/components/ui/ContextMenu/ContextMenu';
import { useAuth } from '@/contexts/useAuth';
import { ActiveDevicesModal } from '@/components/Layout/ActiveDevicesModal';
import { authUserDisplayName } from '@/utils/authUserDisplayName';
import '@/components/ui/ContextMenu/ContextMenu.css';
import './NavbarUserMenu.css';

export function NavbarUserMenu() {
  const { user, logout } = useAuth();
  const btnRef = useRef<HTMLButtonElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [devicesOpen, setDevicesOpen] = useState(false);

  const displayName = useMemo(() => (user ? authUserDisplayName(user) : ''), [user]);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  const toggleMenu = useCallback(() => {
    setMenuOpen((open) => !open);
  }, []);

  const handleLogout = useCallback(() => {
    closeMenu();
    void logout();
  }, [closeMenu, logout]);

  const handleOpenDevices = useCallback(() => {
    closeMenu();
    setDevicesOpen(true);
  }, [closeMenu]);

  if (!user) return null;

  return (
    <>
      <Button
        ref={btnRef}
        type="button"
        variant="primary"
        size="s"
        className="navbar-user-menu__trigger"
        onClick={toggleMenu}
        aria-expanded={menuOpen}
        aria-haspopup="menu"
        aria-controls="navbar-user-menu"
        title={displayName}
        aria-label={`Меню пользователя: ${displayName}`}
      >
        {displayName}
      </Button>

      <ContextMenu
        isOpen={menuOpen}
        onClose={closeMenu}
        anchorPosition={null}
        anchorEl={menuOpen ? btnRef.current : null}
        anchorPriorityAxis="y"
        excludeRefs={[btnRef]}
        items={[
          { label: 'Активные устройства', onClick: handleOpenDevices },
          { label: 'Выйти', danger: true, onClick: handleLogout },
        ]}
      />

      <ActiveDevicesModal open={devicesOpen} onClose={() => setDevicesOpen(false)} />
    </>
  );
}
